<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES87UC3']['0'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC3']['20'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="desc_codempid" name="desc_codempid">{{ detail.tab1.desc_codempid }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC3']['30'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="dtereq" name="dtereq">{{ setDateOutput(detail.tab1.dtereq) }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC3']['40'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="dteeffec" name="dteeffec">{{ setDateOutput(detail.tab1.dteeffec) }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC3']['50'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="coddesc_codexemp" name="coddesc_codexemp">{{ detail.tab1.codexemp }} - {{ detail.tab1.desc_codexemp }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC3']['60'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50 txtarea-width response-full-width" id="desnote" name="desnote">{{ detail.tab1.desnote }}</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES87UC4']['0'] }}
          </h3>
        </div>
        <div id="details2" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive panel-detail-filter">
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC4']['20'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab2.detail.codempid }} - {{ detail.tab2.detail.desc_codempid }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC4']['30'] }}</div>
                <div class="detail-right">
                     <div class="detail-text width-50" id="coddesc_codpos" name="coddesc_codpos">{{ detail.tab2.detail.codpos }} - {{ detail.tab2.detail.desc_codpos }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC4']['40'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="intwno" name="intwno">{{ detail.tab2.detail.intwno }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC4']['50'] }}</div>
                <div class="detail-right">
                   <!--  <select class="select-box response-full-width" name="numqes" id="numqes" onchange="genDetailTab2(this.value)">
                        <option value=""></option>
                    </select> -->
                    <div class="input-group width-50">
                      <hrms-dropdown v-model="numqes" :options="arrNumqes[nowLang]" /> 
                    </div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC4']['70'] }}</div>
                <div class="detail-right">
                  <template v-if="detail.tab2.table.rows.length > 0">
                    <template v-for="detailTab2Answer in filterDetailTab2Answer(detail.tab2.table.rows)" v-if="'' + detailTab2Answer.typeques === '1'">
                      <div class="detail-text width-50 txtarea-width response-full-width" id="response" name="response">{{ detailTab2Answer.response }}</div>
                    </template>
                    <template v-else>
                      <div id="response">
                        <div v-for="ansNo in splitAns(detailTab2Answer.all_answer).length" :id="'response-' + ansNo">
                          <input type="radio" :value="splitNumAns(splitAns(detailTab2Answer.all_answer), ansNo)[0]" v-model="detailTab2Answer.response" name="radio1" disabled="disabled" />
                          <span class="radio-text">{{ splitNumAns(splitAns(detailTab2Answer.all_answer), ansNo)[1] }}</span>
                        </div>
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div class="detail-text width-50 txtarea-width response-full-width" id="response" name="response">No data found.</div>
                  </template>
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details3">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES87UC5']['0'] }}
          </h3>
        </div>
        <div id="details3" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive panel-detail-filter">
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC8']['20'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab2.detail.codempid }} - {{ detail.tab2.detail.desc_codempid }}</div>
                </div>
              </div>    
            </div>

            <hrms-table :columns="tab3Table" :data="detail.tab3.table" />

          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details4">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES87UC6']['0'] }}
          </h3>
        </div>
        <div id="details4" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive panel-detail-filter">
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC8']['20'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab2.detail.codempid }} - {{ detail.tab2.detail.desc_codempid }}</div>
                </div>
              </div>       
            </div>

            <hrms-table :columns="tab4Table" :data="detail.tab4.table" />

          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details5">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES87UC7']['0'] }}
          </h3>
        </div>
        <div id="details5" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive panel-detail-filter">

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC7']['30'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="amtrepaym" name="amtrepaym">{{ detail.tab5.amtrepaym }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC7']['40'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="qtyrepaym" name="qtyrepaym">{{ detail.tab5.qtyrepaym }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC7']['50'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="dtestrpm" name="dtestrpm">{{ setDateOutput(detail.tab5.dtestrpm) }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC7']['60'] }}</div>
                <div class="detail-right">
                   <div class="detail-text width-50" id="amt" name="amt">{{ detail.tab5.amt }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC7']['70'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="amttotpay" name="amttotpay">{{ detail.tab5.amttotpay }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC7']['80'] }}</div>
                <div class="detail-right">
                   <div class="detail-text width-50" id="amtoutstd" name="amtoutstd">{{ detail.tab5.amtoutstd }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC7']['90'] }}</div>
                <div class="detail-right">
                   <div class="detail-text width-50" id="dtelstpay" name="dtelstpay">{{ setDateOutput(detail.tab5.dtelstpay) }}</div>
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details6">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES87UC8']['0'] }}
          </h3>
        </div>
        <div id="details6" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive panel-detail-filter">
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES87UC8']['20'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="coddesc_codempid" name="coddesc_codempid">{{ indexSelected.codempid }} - {{ indexSelected.desc_codempid }}</div>
                </div>
              </div>        
            </div>

            <hrms-table :columns="tab6Table" :data="detail.tab6.table" />

          </div>
        </div>
      </div>


    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres87u-detail',
  data () {
    return {
      numqes: '1'
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    filterDetailTab2Answer (detailTab2Rows) {
      let numqes = this.numqes
      return detailTab2Rows.filter(function (detailTab2Row) {
        return detailTab2Row.numqes === numqes
      })
    },
    splitAns (allAnswer) {
      return allAnswer.split('#@#')
    },
    splitNumAns (splitAns, ansNo) {
      return splitAns[ansNo - 1].split('%@%')
    }
  },
  props: [ 'labels', 'labelsButton', 'detail', 'toggle', 'indexSelected', 'data', 'nowLang', 'arrNumqes', 'tab3Table', 'tab4Table', 'tab6Table' ]
}
</script>



// WEBPACK FOOTER //
// detail.vue?36d630ed